<h3>Main Timeline</h3>

<a class="btn btn-primary" href='main-timeline/vertical'>Vertical</a>